<template lang="pug">
	modal(:max-width="300")
		.card.text-left
			.card-header
				span.fa.fa-folder.mr-2
				| Buzón
				button.close(@click="cerrar") &times;
			.card-body
				.form-group
					label Buzón padre
					input.form-control(disabled="true", :value="padre.nombre")
				hr
				.form-group
					label Nombre del buzón
					input.form-control(ref="nombre", v-model="buzon.nombre")
			.card-footer
				button.btn.btn-primary(@click="guardar")
					span.fa.fa-save.mr-2
					| Guardar
</template>

<script>
import { mapActions } from 'vuex'
export default {
	props: ['padre', 'buzon'],
	mounted () {
		this.$refs.nombre.focus()
	},
	methods: {
		...mapActions({
			setBuzon: 'organizar-emisoras/setBuzonFavorito'
		}),
		cerrar () {
			this.$emit('cerrar')
		},
		guardar () {
			const url = (this.buzon.ID_buzon) ? 'editar-buzon.php' : 'nuevo-buzon.php'
			const data = {
				url: url,
				buzon: this.buzon
			}
			this.setBuzon(data)
			this.cerrar()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/organizar-emisoras/vue/paginas/organizar/editor-favoritos.vue